import {Form} from 'antd'
import apiBaseline from '@/biz/baseline/apiBaseline.mjs'
import http from '@/biz/http.mjs'
import Checkbox from '@/components/Form/Checkbox.jsx'
import TextArea from '@/components/Form/TextArea.jsx'
import {Modal, useOpenModal} from '@/components/Modal/index.mjs'
import {AbortError} from '@/script/Error.mjs'
import runAsync from '@/script/runAsync.mjs'
import useSwrNoCache from '@/script/useSwrNoCache.mjs'
import useBizNode from '../../useBizNode.mjs'

const FormItemUpgrade = ({prjId, sVer, ...props}) => {
    const {data} = useSwrNoCache(
        () => apiBaseline.read({prjId, sVer})
    )

    if ('INCREMENT' === data?.pblType) {
        return null
    }

    return (
        <Form.Item name="upgradeDp" {...props}>
            <Checkbox>制品升版</Checkbox>
        </Form.Item>
    )
}

const ModalPublish = ({prjId, sVer, onOk, ...props}) => {
    const [form] = Form.useForm()

    const handleOk = () => {
        form.submit()
    }

    const cssForm = {
        '.ant-form-item': {
            marginBottom: 0,
        }
    }

    return (
        <Modal
            title="发布模型制品"
            width={400}
            {...props}
            onOk={handleOk}
            onFinish={onOk}
            css={cssForm}
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={onOk}
            >
                <Form.Item name="memo">
                    <TextArea
                        autoSize={false}
                        rows={5}
                        placeholder="备注"
                    />
                </Form.Item>

                <FormItemUpgrade
                    prjId={prjId}
                    sVer={sVer}
                />
            </Form>
        </Modal>
    )
}

export default () => {
    const openModal = useOpenModal()
    const BizNode = useBizNode()

    return {
        async publish() {
            const {bizNodeType, pkid, prjId, sVer} = this.dp
            const {api} = BizNode[bizNodeType]

            const extra = await openModal(
                <ModalPublish
                    prjId={prjId}
                    sVer={sVer}
                />
            )

            if (! extra) {
                throw new AbortError()
            }

            await runAsync(
                async () => {
                    await api.updateMap({...this.dp, dpContent: this.content})

                    const {
                        dpContent: _,
                        dppChangeList,
                        ...updates
                    } = await api.publish({...extra, pkid, prjId, sVer})

                    this.setDp({...this.dp, ...updates})
                },

                {
                    action: '发布',
                    success: {show: true},
                }
            )
        },

        async refresh() {
            const {bizNodeType, pkid} = this.dp
            const {api} = BizNode[bizNodeType]

            await runAsync(
                async () => {
                    const {
                        dpContent,
                        ...dp
                    } = await api.read({pkid})

                    dp.bizNodeType = bizNodeType
                    this.setContent(dpContent)
                    this.setDp(dp)
                },

                {
                    action: '重载',
                    success: {show: true},
                }
            )
        },

        async revise() {
            const {bizNodeType, pkid, prjId, sVer} = this.dp
            const {api} = BizNode[bizNodeType]

            await runAsync(
                async () => {
                    const {
                        dpContent: _,
                        ...updates
                    } = await api.revise({pkid, prjId, sVer})

                    this.setDp({...this.dp, ...updates})
                },

                {
                    action: '修订',
                    success: {show: true},
                }
            )
        },

        async save() {
            const {content, dp} = this
            const {api} = BizNode[dp.bizNodeType]

            await runAsync(
                () => api.updateMap({...dp, dpContent: content}),

                {
                    action: '保存',
                    success: {show: true},
                }
            )
        },

        async undoRevise() {
            const {pkid, prjId, sVer} = this.dp

            await runAsync(
                async () => {
                    const {dataMap} = await http.get(
                        '/basmapvers/latestVer',
                        {dataId: pkid, prjId, sVer}
                    )

                    console.log(JSON.parse(dataMap))
                },

                {
                    action: '撤销修订',
                    success: {show: true},
                }
            )
        },
    }
}
